/**
 * Get the backend API URL
 * - If REACT_APP_BACKEND_URL is set, use it (for preview/development)
 * - Otherwise, use the current origin (for production)
 */
export const getBackendUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl && envUrl.trim() !== '') {
    return envUrl;
  }
  
  // Fallback to current origin for production
  return window.location.origin;
};

/**
 * Get the full API base URL (backend URL + /api)
 */
export const getApiUrl = () => {
  return `${getBackendUrl()}/api`;
};
